module.exports = __webpack_public_path__ + "img/9.d45b3940.jpg";